import { useMemo } from 'react';

import { useI18n } from '@change-corgi/core-react/i18n';
import { getLocaleBasedExperimentVariantsFromName } from '@change-corgi/fcm/utils';

import { usePetitionDetailsPageUserData } from '#src/app/pages/petitionDetails/pageContext';

type GdprCopy = Readonly<{
	prompt: string;
	opt_in: string;
	opt_out: string;
	opt_out_warning: string;
	form_error: string;
}>;

export type GdprConfig = Readonly<{
	enabled: boolean;
	overridden: boolean;
	copy: GdprCopy;
}>;

export function useGdprConfig(): GdprConfig {
	const {
		data: {
			experiments: { gdprSignOptInCopy: fcmExperiment },
		},
	} = usePetitionDetailsPageUserData();
	const {
		data: { gdprConsentProvided },
	} = usePetitionDetailsPageUserData();

	const { translate } = useI18n();

	return useMemo(() => {
		const copyOverride =
			fcmExperiment.config.copy &&
			getLocaleBasedExperimentVariantsFromName(fcmExperiment.config.copy, fcmExperiment.experimentName)?.[
				fcmExperiment.variation
			];

		const copy = {
			prompt: '',
			opt_in: translate('fe.sign_form.marketing_consent.opt_in'),
			opt_out: translate('fe.sign_form.marketing_consent.opt_out'),
			opt_out_warning: translate('fe.sign_form.marketing_consent.opt_out_warning'),
			form_error: translate('fe.sign_form.marketing_consent.form_error'),
			...copyOverride,
		};
		const enabled = fcmExperiment.config.enabled && !gdprConsentProvided;
		return {
			enabled,
			overridden: !!copyOverride,
			copy,
		};
	}, [fcmExperiment, gdprConsentProvided, translate]);
}
